import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import dayjs from "dayjs";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import { UtilService } from "../../services/shared/UtilService";
import {
  assignType,
  categoryType,
  fareType,
  flatType,
  hotelType,
  supplierType,
} from "../../constants/constant";

export const AddHotelCommission = () => {
  const [open, setOpen] = React.useState(false);
  const [categoriesList, setCategoriesList] = useState([
    {
      label: "Add new Category",
      value: "Add new Category",
      id: -1,
    },
  ]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    getCategoriesList();
  }, []);

  const getCategoriesList = async () => {
    try {
      const res = await UtilService.categoriesList();
      if (!!res) {
        const data =
          res.data?.map((i: { name: string; id: number }) => ({
            label: i?.name,
            value: i?.name,
            id: i?.id,
          })) || [];

        setCategoriesList((prev) => [...prev, ...data]);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  const [rows, setRows] = useState([
    {
      type: "",
      supplier_name: "",
      hotel_type: "",
      assign_type: "",
      fare: "",
      flat: "",
      book_form_date: null,
      book_to_date: null,
      checkIn_date: null,
      checkOut_date: null,
    },
  ]);

  // const removeRow = (indexToRemove: number) => {
  //     const updated = rows.filter((_, i) => i !== indexToRemove);
  //     setRows(updated);
  // };

  const initialValues = {
    category: "",
    categoryName: "",
    commissions: [
      {
        categoryId: "",
        commissionType: "",
        supplierName: "",
        hotelType: "",
        assignType: "",
        basicFare: "",
        flat: "",
        bookFrom: "",
        bookTo: "",
        checkIn: "",
        checkOut: "",
      },
    ],
  };

  const removeRow = (indexToRemove: number) => {
    const updated = rows.filter((_, i) => i !== indexToRemove);
    setRows(updated);
  };

  const formik = useFormik({
    initialValues,
    onSubmit(values, formikHelpers) {},
  });

  return <></>;
  //   return (
  //       <div className="row">
  //           <div className="col-md-12">
  //               <div className="card card-custom">
  //                   <div className="card-body">
  //                       <div className="row mt-4">
  //                           <div className="col-md-4">
  //                               <MuiSearchSelect
  //                                   label="Assigned Category"
  //                                   onChange={(value) => {
  //                                       formik.setFieldValue("category", value);
  //                                   }}
  //                                   value={formik.values.category}
  //                                   placeholder="Assigned Category"
  //                                   options={categoriesList}
  //                               />
  //                           </div>
  //                           {formik.values.category === "Add new Category" && (
  //                               <div className="col-md-4">
  //                                   <MuiInput
  //                                       label="Category Name"
  //                                       placeholder="Category Name"
  //                                       value={formik.values.categoryName}
  //                                       onChange={(e) => formik.setFieldValue("categoryName", e)}
  //                                   />
  //                               </div>
  //                           )}
  //                       </div>

  //                       <div className="row mt-4">
  //                           <div className="card card-grid min-w-full">
  //                               <div className="card-body">
  //                                   <div
  //                                       style={{
  //                                           overflowX: "scroll",
  //                                           maxWidth: "100%",
  //                                       }}
  //                                   >
  //                                       <table className="hotel-comission-table table table-bordered">
  //                                           <thead>
  //                                               <tr>
  //                                                   <th style={{ width: 50 }}>Type</th>
  //                                                   <th className="min-w-[100px]">
  //                                                       Supplier Name
  //                                                   </th>
  //                                                   <th>Hotel Type</th>
  //                                                   <th>Assign Type</th>
  //                                                   <th className="min-w-[150px]">
  //                                                       Basic Fare(%)
  //                                                   </th>
  //                                                   <th>Flat</th>
  //                                                   <th className="min-w-[100px]">
  //                                                       Book From Date
  //                                                   </th>
  //                                                   <th className="min-w-[100px]">
  //                                                       Book To Date
  //                                                   </th>
  //                                                   <th>Check-In-Date</th>
  //                                                   <th>Check-Out-Date</th>
  //                                                   <th>Click</th>

  //                                               </tr>
  //                                               <tr></tr>
  //                                           </thead>
  //                                           {formik.values.commissions.map((row: any, index: number) => (
  //                                               <tbody key={index}>
  //                                                   <tr className="fareview">
  //                                                       <td className="align-middle text-center">
  //                                                           <MuiSearchSelect
  //                                                               value={row.commissionType}
  //                                                               onChange={(value) =>
  //                                                                   formik.setFieldValue(
  //                                                                       `commissions[${index}].commissionType`,
  //                                                                       value
  //                                                                   )
  //                                                               }
  //                                                               options={categoryType}
  //                                                               placeholder="Type"
  //                                                           />
  //                                                       </td>
  //                                                       <td className="align-middle text-center">
  //                                                           <MuiSearchSelect
  //                                                               value={row.supplierName}
  //                                                               onChange={(value) =>
  //                                                                   formik.setFieldValue(
  //                                                                       `commissions[${index}].supplierName`,
  //                                                                       value
  //                                                                   )
  //                                                               }
  //                                                               options={supplierType}
  //                                                               placeholder="Supplier Name"
  //                                                           />
  //                                                       </td>
  //                                                       <td className="align-middle text-center">
  //                                                           <MuiSearchSelect
  //                                                               value={row.hotelType}
  //                                                               onChange={(value) =>
  //                                                                   formik.setFieldValue(
  //                                                                       `commissions[${index}].hotelType`,
  //                                                                       value
  //                                                                   )
  //                                                               }
  //                                                               options={hotelType}
  //                                                               placeholder="Hotel Type"
  //                                                           />
  //                                                       </td>
  //                                                       <td className="align-middle text-center">
  //                                                           <MuiSearchSelect
  //                                                               value={row.assignType}
  //                                                               onChange={(value) =>
  //                                                                   formik.setFieldValue(
  //                                                                       `commissions[${index}].assignType`,
  //                                                                       value
  //                                                                   )
  //                                                               }
  //                                                               options={assignType}
  //                                                               placeholder="Assign Type"
  //                                                           />
  //                                                       </td>

  //                                                       <td className="align-middle text-center">
  //                                                           <MuiSearchSelect
  //                                                               value={row.basicFare}
  //                                                               onChange={(value) =>
  //                                                                   formik.setFieldValue(
  //                                                                       `commissions[${index}].basicFare`,
  //                                                                       value
  //                                                                   )
  //                                                               }
  //                                                               options={fareType}
  //                                                               placeholder="Basic Fare"
  //                                                           />
  //                                                       </td>
  //                                                       <td className="align-middle text-center">
  //                                                           <MuiSearchSelect
  //                                                               value={row.flat}
  //                                                               onChange={(value) =>
  //                                                                   formik.setFieldValue(
  //                                                                       `commissions[${index}].flat`,
  //                                                                       value
  //                                                                   )
  //                                                               }
  //                                                               options={flatType}
  //                                                               placeholder="Flat Type"
  //                                                           />
  //                                                       </td>
  //                                                       <td className="align-middle text-center">
  //                                                           <MuiDatePicker
  //                                                               value={row.bookFrom ? dayjs(row.BookFrom) : null}
  //                                                               onChange={(value) =>
  //                                                                   formik.setFieldValue(
  //                                                                       `commissions[${index}].bookFrom`,
  //                                                                       value
  //                                                                   )
  //                                                               }
  //                                                           />
  //                                                       </td>
  //                                                       <td>
  //                                                           <MuiDatePicker
  //                                                               value={row.bookTo ? dayjs(row.BookTo) : null}
  //                                                               onChange={(value) =>
  //                                                                   formik.setFieldValue(
  //                                                                       `commissions[${index}].bookTo`,
  //                                                                       value
  //                                                                   )
  //                                                               }
  //                                                           />
  //                                                       </td>
  //                                                       <td>
  //                                                           <MuiDatePicker
  //                                                               value={row.checkIn ? dayjs(row.CheckIn) : null}
  //                                                               onChange={(value) =>
  //                                                                   formik.setFieldValue(
  //                                                                       `commissions[${index}].checkIn`,
  //                                                                       value
  //                                                                   )
  //                                                               }
  //                                                           />
  //                                                       </td>
  //                                                       <td>
  //                                                           <MuiDatePicker
  //                                                               value={row.checkOut ? dayjs(row.CheckOut) : null}
  //                                                               onChange={(value) =>
  //                                                                   formik.setFieldValue(
  //                                                                       `commissions[${index}].checkOut`,
  //                                                                       value
  //                                                                   )
  //                                                               }
  //                                                           />
  //                                                       </td>
  //                                                       <td className="align-middle text-center">
  //                                                           <button className="b" type="button">+</button>
  //                                                           {/* {rows.length > 1 && index !== 0 && (
  //                                                               <button className="mx-2" type="button" onClick={() => removeRow(index)}>−</button>
  //                                                           )} */}
  //                                                       </td>

  //                                                   </tr>
  //                                               </tbody>
  //                                           ))}
  //                                       </table>
  //                                   </div>
  //                                   <div className="user-button w-full mt-4 ">
  //                                       <MuiButton
  //                                           className="clear-btn "
  //                                           label="Cancel"
  //                                           type="submit"
  //                                       />
  //                                       <MuiButton
  //                                           className="main-btn get-btn"
  //                                           variant="contained"
  //                                           size="large"
  //                                           type="submit"
  //                                           label={"submit"}
  //                                       />
  //                                   </div>
  //                               </div>
  //                           </div>
  //                       </div>
  //                   </div>
  //               </div>

  //           </div>

  //           <div className="row mt-4">
  //             <div className="card card-grid min-w-full">
  //               <div className="card-body">
  //                 <div
  //                   style={{
  //                     overflowX: "scroll",
  //                     maxWidth: "100%",
  //                   }}
  //                 >
  //                   <table className="hotel-comission-table table table-bordered">
  //                     <thead>
  //                       <tr>
  //                         <th style={{ width: 50 }}>Type</th>
  //                         <th className="min-w-[100px]">Supplier Name</th>
  //                         <th>Hotel Type</th>
  //                         <th>Assign Type</th>
  //                         <th className="min-w-[150px]">Basic Fare(%)</th>
  //                         <th>Flat</th>
  //                         <th className="min-w-[100px]">Book From Date</th>
  //                         <th className="min-w-[100px]">Book To Date</th>
  //                         <th>Check-In-Date</th>
  //                         <th>Check-Out-Date</th>
  //                         <th>Click</th>
  //                       </tr>
  //                       <tr></tr>
  //                     </thead>
  //                     {rows.map((row, index) => (
  //                       <tbody key={index}>
  //                         <tr className="fareview">
  //                           <td className="align-middle text-center">
  //                             <MuiSearchSelect
  //                               label="Commision Type  "
  //                               placeholder={"Commision Type"}
  //                               options={[]}
  //                               onChange={(value, id, data) => {
  //                                 formik.setFieldValue("commissionType", value);
  //                               }}
  //                               onBlur={() =>
  //                                 formik.setFieldTouched("commissionType", true)
  //                               }
  //                               value={formik.values.commissionType}
  //                             />
  //                           </td>
  //                           <td className="align-middle text-center">
  //                             <MuiInput
  //                               placeholder="Supplier Name"
  //                               label={"Supplier Name"}
  //                               onChange={(value) =>
  //                                 formik.setFieldValue("supplierName", value)
  //                               }
  //                               onBlur={() =>
  //                                 formik.setFieldTouched("supplierName", true)
  //                               }
  //                               value={formik.values.supplierName}
  //                             />
  //                           </td>
  //                           <td className="align-middle text-center">
  //                             <MuiSearchSelect
  //                               label="Hotel Type"
  //                               placeholder={"Hotel Type"}
  //                               options={[]}
  //                               onChange={(value, id, data) => {
  //                                 formik.setFieldValue("hotelType", value);
  //                                 formik.setFieldValue("hotelType", data.code);
  //                               }}
  //                               onBlur={() =>
  //                                 formik.setFieldTouched("hotelType", true)
  //                               }
  //                               value={formik.values.hotelType}
  //                             />
  //                           </td>
  //                           <td className="align-middle text-center">
  //                             <MuiSearchSelect
  //                               label="Assign Type"
  //                               placeholder={"Assign Type"}
  //                               options={[]}
  //                               onChange={(value, id, data) => {
  //                                 formik.setFieldValue("assignType", value);
  //                                 formik.setFieldValue("assignType", data.code);
  //                               }}
  //                               onBlur={() =>
  //                                 formik.setFieldTouched("assignType", true)
  //                               }
  //                               value={formik.values.assignType}
  //                             />
  //                           </td>

  //                           <td className="align-middle text-center">
  //                             <MuiInput
  //                               placeholder="Basic Fare"
  //                               label={"Basic Fare"}
  //                               onBlur={() =>
  //                                 formik.setFieldTouched("basicFare", true)
  //                               }
  //                               value={formik.values.basicFare}
  //                             />
  //                           </td>
  //                           <td className="align-middle text-center">
  //                             <MuiInput
  //                               placeholder="Flat"
  //                               label={"Flat"}
  //                               onChange={(value) =>
  //                                 formik.setFieldValue("flat", value)
  //                               }
  //                               onBlur={() =>
  //                                 formik.setFieldTouched("flat", true)
  //                               }
  //                               value={formik.values.flat}
  //                             />
  //                           </td>
  //                           <td className="align-middle text-center">
  //                             <MuiDatePicker
  //                               label="Date of Joining"
  //                               value={
  //                                 formik.values.bookFrom
  //                                   ? dayjs(formik.values.bookFrom)
  //                                   : null
  //                               }
  //                               onChange={(date: string) => {
  //                                 formik.setFieldValue("bookFrom", date);
  //                               }}
  //                               // onBlur={() => formik.setFieldTouched("date", true)} // Mark as touched
  //                             />
  //                           </td>
  //                           <td>
  //                             <MuiDatePicker
  //                               label="Date of Joining"
  //                               value={
  //                                 formik.values.bookTo
  //                                   ? dayjs(formik.values.bookTo)
  //                                   : null
  //                               }
  //                               onChange={(date: string) => {
  //                                 formik.setFieldValue("bookTo", date);
  //                               }}
  //                               // onBlur={() => formik.setFieldTouched("date", true)} // Mark as touched
  //                             />
  //                           </td>
  //                           <td>
  //                             <MuiDatePicker
  //                               label="Date of Joining"
  //                               value={
  //                                 formik.values.checkIn
  //                                   ? dayjs(formik.values.checkIn)
  //                                   : null
  //                               }
  //                               onChange={(date: string) => {
  //                                 formik.setFieldValue("checkIn", date);
  //                               }}
  //                               // onBlur={() => formik.setFieldTouched("date", true)} // Mark as touched
  //                             />
  //                           </td>
  //                           <td>
  //                             <MuiDatePicker
  //                               label="Date of Joining"
  //                               value={
  //                                 formik.values.checkOut
  //                                   ? dayjs(formik.values.checkOut)
  //                                   : null
  //                               }
  //                               onChange={(date: string) => {
  //                                 formik.setFieldValue("checkOut", date);
  //                               }}
  //                               // onBlur={() => formik.setFieldTouched("date", true)} // Mark as touched
  //                             />
  //                           </td>
  //                           <td className="align-middle text-center">
  //                             <button
  //                               className="b"
  //                               type="button"
  //                               onClick={addNewRow}
  //                             >
  //                               +
  //                             </button>
  //                             {rows.length > 1 && index !== 0 && (
  //                               <button
  //                                 className="mx-2"
  //                                 type="button"
  //                                 onClick={() => removeRow(index)}
  //                               >
  //                                 −
  //                               </button>
  //                             )}
  //                           </td>
  //                         </tr>
  //                       </tbody>
  //                     ))}
  //                   </table>
  //                 </div>
  //                 <div className="user-button w-full mt-4 ">
  //                   <MuiButton
  //                     className="clear-btn "
  //                     label="Cancel"
  //                     type="submit"
  //                   />
  //                   <MuiButton
  //                     className="main-btn get-btn"
  //                     variant="contained"
  //                     size="large"
  //                     type="submit"
  //                     label={"submit"}
  //                   />
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>

  // );
};
